import { useEffect, useRef } from 'react';
import { useQueryClient } from 'react-query';
import { IPaginationParams } from '../../../../types';
import { getStreamByEndpointAsync } from '../../../index';
import { IEventPauseUpdateParams } from '../../../types';
import { SCHOOL_MONITORING_EVENT_ENDPOINT } from '../../index';
import { ISchoolMonitoringFilterProps } from '../../types';
import { SCHOOL_MONITORING_KEYS } from '../useQuery';

interface UseSchoolMonitoringSocketProps {
  pagination: IPaginationParams;
  filter: ISchoolMonitoringFilterProps;
  pausedUpdateParams: IEventPauseUpdateParams;
}

export const useSchoolMonitoringSocket = ({
  pagination,
  filter,
  pausedUpdateParams
}: UseSchoolMonitoringSocketProps) => {
  const queryClient = useQueryClient();

  const isFirstMessage = useRef(true);

  useEffect(() => {
    if (pagination.pageNumber !== 1 || pausedUpdateParams.isPaused) return;

    let isActive = true;
    isFirstMessage.current = true;

    let socketConnection: WebSocket | null = null;

    const fetchData = async () => {
      const connection = await getStreamByEndpointAsync(
        SCHOOL_MONITORING_EVENT_ENDPOINT,
        (newData: any[]) => {

          if (!isActive) return;

          if (isFirstMessage.current) {
             isFirstMessage.current = false;
             return; 
          }

          if (newData && newData.length > 0) {
              const first = newData[0];
              if (!first.studentRecognition && !first.responsible) {
                  return;
              }
          }

          const hasActiveFilter = filter && filter.search && filter.search.trim() !== '';

          if (hasActiveFilter) {
              queryClient.invalidateQueries([SCHOOL_MONITORING_KEYS.ALL, SCHOOL_MONITORING_KEYS.LIST]);
              queryClient.invalidateQueries([SCHOOL_MONITORING_KEYS.ALL, SCHOOL_MONITORING_KEYS.COUNT]);
              return;
          }

          queryClient.setQueryData(
            [SCHOOL_MONITORING_KEYS.ALL, SCHOOL_MONITORING_KEYS.LIST, pagination, filter], 
            (oldData: any) => newData
          );

          queryClient.setQueryData(
            [SCHOOL_MONITORING_KEYS.ALL, SCHOOL_MONITORING_KEYS.COUNT, filter],
            (oldTotal: number | undefined) => {
               return (oldTotal || 0) + 1;
            }
          );

        },
        pagination,
        () => {}, // Callback vazio
        () => {}, // Importante: Passamos func vazia para NÃO disparar o loading global a cada update
        pausedUpdateParams,
        true
      );

      if (!isActive) {
          if (connection) {
             (connection as any)._isIntentionalClose = true;
             connection.close();
          }
          return;
      }

      socketConnection = connection;
    };

    fetchData();

    return () => {
       isActive = false;
       if (socketConnection) {
           (socketConnection as any)._isIntentionalClose = true; 
           socketConnection.close();
       }
    };
  }, [pagination, filter, pausedUpdateParams, queryClient]);
};